export default [
	{
		type: "uni",
		id: 1,
		items: [
			{
				id: 1,
				text: "Der Lehrer/Die Lehrerin hat die Inhalte angemessen präsentiert und wiederholt.",
			},
			{
				id: 2,
				text: "Ich konnte dem Tempo des Lehrers/der Lehrerin gut folgen.",
			},
			{
				id: 3,
				text: "Der Lehrer/Die Lehrerin ermöglichte eine gute Lern- und Arbeitsatmosphäre.",
			},
			{
				id: 4,
				text: "Der Lehrer/Die Lehrerin gab die Möglichkeit Fragen zu stellen.",
			},
			{
				id: 5,
				text: "Der Lehrer/Die Lehrerin war stets gut vorbereitet",
			},
			{
				id: 6,
				text: "Der Lehrer/Die Lehrerin konnte Kompliziertes verständlich machen.",
			},
			{
				id: 7,
				text: "Dem Lehrer/Der Lehrerin war es wichtig, dass die Teilnehmenden etwas lernen.",
			},
			{
				id: 8,
				text: "Der Lehrer/Die Lehrerin motivierte die Teilnehmenden.",
			},
			{
				id: 9,
				text: "Der Lehrer/Die Lehrerin hat die Inhalte interessant vermittelt.",
			},
			{
				id: 10,
				text: "Das von dem Lehrer/der Lehrerin zur Verfügung gestellte Material bzw. die von ihm/ihr eingesetzten Medien waren hilfreich.",
			},
			{
				id: 11,
				text: "Das Lernziel wurde mir deutlich.",
			},
			{
				id: 12,
				text: "Die Veranstaltung war gut strukturiert und verständlich.",
			},
			{
				id: 13,
				text: "Der inhaltliche Aufbau der Veranstaltung war logisch/nachvollziehbar.",
			},
			{
				id: 14,
				text: "Methoden und Arbeitsaufwand waren klar aus der Kursbeschreibung zu entnehmen.",
			},
			{
				id: 15,
				text: "In der Veranstaltung wurden die richtigen Schwerpunkte gesetzt.",
			},
			{
				id: 16,
				text: "Das Thema der Veranstaltung ist als solches relevant.",
			},
			{
				id: 17,
				text: "Ich habe das Gefühl, in der Veranstaltung Wichtiges gelernt zu haben.",
			},
			{
				id: 18,
				text: "Die vermittelten Fertigkeiten sind für meine (spätere) beruﬂiche Tätigkeit relevant.",
			},
			{
				id: 19,
				text: "Die Kursinhalte entsprachen meinen Lernbedürfnissen.",
			},
			{
				id: 20,
				text: "Ich habe in der Veranstaltung Fähigkeiten entwickelt, die für meine beruﬂiche, akademische und/oder persönliche Entwicklung relevant sind.",
			},
			{
				id: 21,
				text: "Die Themen der Veranstaltung haben zur Entwicklung meiner Fremdsprachenfähigkeiten beigetragen.",
			},
			{
				id: 22,
				text: "Ich habe meine eigenen Lernziele erreicht.",
			},
		],
	},
	{
		type: "bi",
		id: 2,
		items: [
			{
				id: 23,
				text: "Die Schwere des Stoffes war...",
			},
			{
				id: 24,
				text: "Der Umfang des Stoffes war...",
			},
			{
				id: 25,
				text: "Das Tempo der Veranstaltung war...",
			},
			{
				id: 26,
				text: "Die Anforderungen der Veranstaltung waren...",
			},
			{
				id: 27,
				text: "Der Zeitaufwand für die Veranstaltung insgesamt (inkl. Vor- und Nachbereitung) war...",
			},
			{
				id: 28,
				text: "Insgesamt empfand ich die Veranstaltung als...",
			},
		],
	},
	{
		type: "uni",
		id: 3,
		items: [
			{
				id: 29,
				text: "Ich habe viel Zeit in die Vor- und Nachbereitung der Veranstaltung investiert.",
			},
			{
				id: 30,
				text: "Ich habe in die Veranstaltung mehr Zeit investiert als in vergleichbare Kurse.",
			},
			{
				id: 31,
				text: "Ich habe mich aktiv in die Veranstaltung eingebracht.",
			},
			{
				id: 32,
				text: "Insgesamt fand ich die Veranstaltung gut.",
			},
			{
				id: 33,
				text: "In der Veranstaltung habe ich viel gelernt.",
			},
			{
				id: 34,
				text: "Ich würde die Veranstaltung weiterempfehlen.",
			},
			{
				id: 35,
				text: "Meine Erwartungen an die Veranstaltung wurden erfüllt.",
			},
		],
	},
	{
		type: "text",
		id: 4,
		items: [
			{
				id: 36,
				text: "Besonders gut fand ich:",
			},
			{
				id: 37,
				text: "Störend fand ich",
			},
			{
				id: 38,
				text: "Was hatten Sie sich von diesem Kurs erhofft?",
			},
		],
	},
];
